"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5824],{

/***/ 75824:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ v1_Text; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./utils/helper.js + 1 modules
var helper = __webpack_require__(55760);
;// CONCATENATED MODULE: ./components/Default/Text/v1/analytics/constant.js
const PAGELOAD = "bathroom design services";
const DESIGNSERVICES = "design services credit details";

;// CONCATENATED MODULE: ./components/Default/Text/v1/analytics/index.js


const datalayerForLinkEvent = (e)=>{
    const { target: { href ="" , textContent =""  } = {}  } = e;
    const eventInfo = {
        clickInternalLinks: "false",
        eventAction: "".concat(PAGELOAD, ":").concat(DESIGNSERVICES, ":").concat(textContent),
        eventMsg: " n/a",
        eventName: "".concat(PAGELOAD, ":").concat(DESIGNSERVICES, ":").concat(textContent),
        eventStatus: " n/a",
        eventType: "help support",
        internalLinkName: textContent,
        internalLinkPosition: DESIGNSERVICES,
        internalLinkType: "".concat(PAGELOAD, ":email us"),
        internalLinkURL: href,
        internalLinkZoneName: "".concat(PAGELOAD, ":").concat(DESIGNSERVICES)
    };
    textContent === "services@kohler.com" ? (0,helper.pushAnalyticsObjToDataLayer)(eventInfo) : null;
};

;// CONCATENATED MODULE: ./components/Default/Text/v1/Text.jsx




const Text = (props)=>{
    const [dataVal, setDataVal] = (0,react.useState)("");
    const linkTextRef = (0,react.useRef)();
    const { data: { text ="" , appliedCssClassNames ="" , richText =false , id =""  } = {}  } = props;
    const removeHtmlExtension = async ()=>{
        const newData = await (0,helper.getShortenedUrl)(text);
        setDataVal(newData);
    };
    (0,react.useEffect)(()=>{
        if (richText) {
            removeHtmlExtension();
        }
    }, [
        richText
    ]);
    (0,react.useEffect)(()=>{
        if (linkTextRef === null || linkTextRef === void 0 ? void 0 : linkTextRef.current) {
            var ref;
            linkTextRef === null || linkTextRef === void 0 ? void 0 : (ref = linkTextRef.current) === null || ref === void 0 ? void 0 : ref.querySelectorAll("a").forEach((item)=>{
                item === null || item === void 0 ? void 0 : item.addEventListener("click", (e)=>{
                    datalayerForLinkEvent(e);
                });
            });
            return ()=>{
                var ref;
                linkTextRef === null || linkTextRef === void 0 ? void 0 : (ref = linkTextRef.current) === null || ref === void 0 ? void 0 : ref.querySelectorAll("a").forEach((item)=>{
                    item === null || item === void 0 ? void 0 : item.removeEventListener("click", (e)=>{
                        datalayerForLinkEvent(e);
                    });
                });
            };
        }
    }, [
        dataVal,
        text
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "text ".concat(appliedCssClassNames ? appliedCssClassNames : ""),
        ref: linkTextRef,
        children: richText ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            id: id,
            className: "cmp-text",
            children: (0,helper.sanitizeInnerHtml)(dataVal)
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "cmp-text",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "cmp-text__paragraph",
                "aria-label": text,
                children: text
            })
        })
    });
};
/* harmony default export */ var v1_Text = (Text);


/***/ })

}]);